import { SxProps, Theme } from "@mui/material";

export const faqItemOpen: SxProps<Theme> = {
  border: "1px solid rgba(56,189,248,0.3)",
  borderRadius: "12px",
  mb: 2,
  overflow: "hidden",
  background: "rgba(56,189,248,0.04)",
  transition: "border 0.2s ease",
};

export const faqItemClosed: SxProps<Theme> = {
  border: "1px solid rgba(56,189,248,0.12)",
  borderRadius: "12px",
  mb: 2,
  overflow: "hidden",
  background: "rgba(255,255,255,0.02)",
  transition: "border 0.2s ease",
};

export const faqItemHeader: SxProps<Theme> = {
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  p: { xs: 2.5, md: 3 },
};

export const faqQuestionOpen: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: { xs: "0.95rem", md: "1.05rem" },
  color: "#38bdf8",
  pr: 2,
};

export const faqQuestionClosed: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: { xs: "0.95rem", md: "1.05rem" },
  color: "white",
  pr: 2,
};

export const faqToggleIcon: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontWeight: 400,
  fontSize: "1.4rem",
  color: "#38bdf8",
  lineHeight: 1,
  flexShrink: 0,
  userSelect: "none",
};

export const faqAnswerContainer: SxProps<Theme> = {
  px: { xs: 2.5, md: 3 },
  pb: { xs: 2.5, md: 3 },
  borderTop: "1px solid rgba(56,189,248,0.1)",
  pt: { xs: 2.5, md: 3 },
};

export const faqAnswerParagraph: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "1rem",
  color: "rgba(255,255,255,0.75)",
  lineHeight: 1.85,
};

export const videoCardIframe: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

export const videoCardOverlayHovered: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(4,9,34,0.3)",
  transition: "background 0.25s ease",
};

export const videoCardOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(4,9,34,0.15)",
  transition: "background 0.25s ease",
};

export const playButtonTriangle: SxProps<Theme> = {
  width: 0,
  height: 0,
  borderTop: "8px solid transparent",
  borderBottom: "8px solid transparent",
  borderLeft: "13px solid white",
  ml: "3px",
};

export const videoCardGradientOverlay: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  background: "linear-gradient(to top, rgba(4,9,34,0.95) 0%, rgba(4,9,34,0.6) 50%, transparent 100%)",
  px: 2,
  pt: 6,
  pb: 2,
};

export const videoCardCategory: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "0.6rem",
  color: "#38bdf8",
  textTransform: "uppercase",
  letterSpacing: "0.12em",
  mb: 0.5,
};

export const videoCardTitle: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: "0.88rem",
  color: "white",
  lineHeight: 1.35,
};

export const heroSection: SxProps<Theme> = {
  minHeight: "100vh",
  background: "#040922",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const heroVideoContainer: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "177.78vh", md: "100vw" },
  height: { xs: "100vh", md: "56.25vw" },
  minWidth: "100vw",
  minHeight: "56.25vw",
};

export const heroVideoIframe: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

export const heroEyebrow: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "0.7rem",
  color: "#38bdf8",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  mb: 3,
};

export const heroHeading: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.8rem", md: "4.5rem", lg: "5.5rem" },
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  mb: 3,
};

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const heroSubtext: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: { xs: "1rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  maxWidth: 520,
  mb: 8,
};

export const heroPlayTriangle: SxProps<Theme> = {
  width: 0,
  height: 0,
  borderTop: { xs: "14px solid transparent", md: "18px solid transparent" },
  borderBottom: { xs: "14px solid transparent", md: "18px solid transparent" },
  borderLeft: { xs: "22px solid white", md: "28px solid white" },
  ml: { xs: "5px", md: "6px" },
};

export const heroStartHere: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "0.8rem",
  color: "rgba(255,255,255,0.4)",
  letterSpacing: "0.1em",
  mt: 3,
  textTransform: "uppercase",
};

export const closeButton: SxProps<Theme> = {
  position: "absolute",
  top: 24,
  right: 24,
  zIndex: 3,
  width: 44,
  height: 44,
  borderRadius: "50%",
  background: "rgba(4,9,34,0.7)",
  border: "1px solid rgba(255,255,255,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  backdropFilter: "blur(8px)",
  "&:hover": { background: "rgba(4,9,34,0.9)" },
};

export const bottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "160px",
  background: "linear-gradient(to bottom, transparent 0%, #040922 100%)",
  pointerEvents: "none",
};

export const tutorialsSectionBg: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  backgroundImage: "radial-gradient(ellipse 80% 60% at 50% 40%, rgba(56,189,248,0.07) 0%, transparent 70%)",
  backgroundAttachment: "fixed",
  pointerEvents: "none",
};

export const sectionEyebrow: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "0.7rem",
  color: "#38bdf8",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  textAlign: "center",
  mb: 2,
};

export const tutorialsSectionHeading: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "2.8rem" },
  color: "white",
  textAlign: "center",
  mb: 2,
};

export const sectionSubtext: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "1rem",
  color: "rgba(255,255,255,0.5)",
  textAlign: "center",
  mb: 8,
};

export const videoGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
  gap: { xs: 3, md: 3 },
};

export const faqSectionBg: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  backgroundImage: "radial-gradient(ellipse 70% 50% at 50% 30%, rgba(56,189,248,0.06) 0%, transparent 70%)",
  backgroundAttachment: "fixed",
  pointerEvents: "none",
};

export const faqSectionTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "100px",
  background: "linear-gradient(to bottom, #040922 0%, #080f1e 100%)",
  pointerEvents: "none",
};

export const faqSectionHeading: SxProps<Theme> = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "2.8rem" },
  textAlign: "center",
  mb: 2,
};

export const faqSectionSubtext: SxProps<Theme> = {
  fontFamily: "Barlow, sans-serif",
  fontSize: "1rem",
  color: "rgba(255,255,255,0.5)",
  textAlign: "center",
  mb: 8,
};
